import { MapEffects } from './map.effects';
import { LocationHistoryEffects } from './location-history.effects';

export const effects: any[] = [MapEffects, LocationHistoryEffects];

export * from './map.effects';
